{
  "url.connect": "/conexao",
  "url.donate": "/doar",
  "url.community": "/comunidade/{id}-{slug}",
  "url.menu.contact": "/contatar",
  "url.menu.introduction": "/pagina/introduction",
  "url.menu.about": "/page/about",
  "url.menu.communities-list": "/lista-de-comunidades",
  "url.menu.cgu": "/pagina/cgu",
  "url.menu.guides-list": "/guides-list"
}
